import React from "react";
import useFormWizard from "../FormWizardProvider";
import "./InlineFormRenderer.scss";

export type InlineFormRendererProps = {
  children: React.ReactNode;
  className?: string;
};

const InlineFormRenderer: React.FC<InlineFormRendererProps> = ({
  children,
  className,
}) => {
  const { activeStepIndex, activeStep, formSteps } = useFormWizard();

  return (
    <div className={`inline-form-wizard-wrapper ${className}`}>
      {formSteps?.length > 1 && (
        <div className="step-counter" data-testid={"form-step-counter"}>
          Step {activeStepIndex + 1}/{formSteps?.length}
        </div>
      )}
      <div
        className="step-wrapper"
        // `activeStep` is always set here: FormRenderer only mounts this
        // renderer inside a `!!activeStep` guard (matches original JS).
        key={activeStep!.id}
        data-testid={`form-step-${activeStep!.id}`}
      >
        {children}
      </div>
    </div>
  );
};

export default InlineFormRenderer;
